import cnBind from "classnames/bind";
import Link from "next/link"; // ДОБАВИЛИ ИМПОРТ NEXT LINK
import type { CreateNewsDto } from "@/entities/types/entities";
import { API_BASE } from "@/shared/constants/private";
import { CustomImage } from "@/shared/ui/CustomImage";
import styles from "./CardArticle.module.scss";

const cx = cnBind.bind(styles);

type Props = {
    className?: string;
    item: CreateNewsDto;
    url: string;
};

export const CardArticle = ({ item, className, url }: Props) => {
    const articleHref = `${url}/${item.urlTitle || ""}`;

    return (
        <article className={cx("card", className)}>
            <div className={cx("image")}>
                <CustomImage
                    width={293}
                    height={165}
                    src={`${API_BASE}/picture/${item.pictureId}`}
                    alt={item.title || ""}
                    priority
                />
            </div>

            <div className={cx("body")}>
                <div className={cx("info")}>
                    <h3 className={cx("title")}>
                        <Link href={articleHref} className={cx("link-overlay")}>
                            {item.title}
                        </Link>
                    </h3>
                </div>
            </div>
        </article>
    );
};
